import Icon from "../components/Icon/Icon";
import { FiMusic } from "react-icons/fi";
import { FaInstagram } from "react-icons/fa";
import { FacebookSocialIcon } from "./socials";
import { IoLogoTiktok } from "react-icons/io5";
import { FaSpotify } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { FaApple } from "react-icons/fa";
import { PiYoutubeLogo } from "react-icons/pi";
import { FaSoundcloud } from "react-icons/fa6";
import { FaBandcamp } from "react-icons/fa";
import { FaVimeo } from "react-icons/fa";
import wjfIcon from "../assets/icons/wjf-logo.png";
import websiteIcon from "../assets/icons/website.svg";
import { backendUrl } from "../api/constants";

// dynamicIconRegistry.js
const iconRegistry = {
  FiMusic: {
    icon: FiMusic,
  },
  FaInstagram: {
    icon: FaInstagram,
  },
  IoLogoFacebook: {
    icon: FacebookSocialIcon,
  },
  IoLogoTiktok: {
    icon: IoLogoTiktok,
  },
  FaSpotify: {
    icon: FaSpotify,
  },
  FaXTwitter: {
    icon: FaXTwitter,
  },
  FaApple: {
    icon: FaApple,
  },
  FaYoutube: {
    icon: PiYoutubeLogo,
  },
  FaSoundcloud: {
    icon: FaSoundcloud,
  },
  FaBandcamp: {
    icon: FaBandcamp,
  },
  FaVimeo: {
    icon: FaVimeo,
  },
  websiteIcon: {
    icon: (props) => <Icon src={websiteIcon} {...props} />,
    img: websiteIcon,
  },
  wjfIcon: {
    icon: (props) => (
      <Icon
        src={wjfIcon}
        {...props}
        className={`grayscale-[0.5] flex items-center justify-center ${props?.className}`}
      />
    ),
    img: wjfIcon,
  },
};

export const getKnownServiceImg = (iconPath) => {
  // If it's a registered icon, return from registry
  if (iconRegistry[iconPath]?.img) {
    return iconRegistry[iconPath].img;
  }
  // Otherwise, it's a dynamic icon path, prepend backend URL
  return `${backendUrl}/${iconPath}`;
}

export const loadIcon = (iconPath, props) => {
  // If it's a registered icon, return from registry
  if (iconRegistry[iconPath]?.icon) {
    const IconComponent = iconRegistry[iconPath].icon;
    return <IconComponent {...props} />;
  }
  // Otherwise, it's a dynamic icon path
  return <Icon src={iconPath} {...props} />;
};

export default iconRegistry;
